import './YearToDateTableV2.scss';

import { object } from 'prop-types';
import React, {
  useEffect
} from 'react';
import { connect } from 'react-redux';

import {
  AAMBeaconControl,
  AAMBeaconTab,
  AAMBeaconTabPanel,
  AAMBeaconTabs
} from 'components/shared/Beacon';

import {
  getDefaultTaxYear,
  getYtdTaxInformation
} from 'state/taxes/TaxSelectors';
import { YEAR_OPTIONS } from 'services/Taxes';
import Store from 'state/Store';
import { selectTaxFiltering } from 'state/taxes/TaxActions';
import Option from 'components/shared/SelectOption/Option';
import TaxonomyTables from "./YearToDateTableV2/TaxonomyTables";
import PageLoadingSpinner from "../Navigation/PageLoadingSpinner";
import {
  getHasErrorTaxonomy,
  getHasReceivedTaxFiltering,
  getHasReceivedTaxonomy
} from "state/requests/RequestStatusSelectors";
import {getCustomerWebView, getUberId} from "../../../state/customer/CustomerSelectors";

const YearToDateTableV2 = (props) => {

  useEffect(() => {
    Store.dispatch(selectTaxFiltering('all'));
  }, []);

  const handleAccountGroupChange = (e) => {
    Store.dispatch(selectTaxFiltering(e.target.value));
  };

  const {
    taxFilter,
    taxonomyDataV2,
    ytdTaxInformation,
    hasReceivedTaxonomyData,
    hasTaxonomyDataError,
    isRetirementAdvisoryServiceClient,
    hasReceivedTaxFiltering,
    isCWV,
    uberId,
  } = props;

  taxFilter.options.sort((a, b) => a.label.localeCompare(b.label));

  if ((hasReceivedTaxonomyData || hasTaxonomyDataError) && hasReceivedTaxFiltering) {
    return (
        <div className="year-to-date-table-wrapper-v2">
          <div className="year-to-date-table-header-v2 b-typography-sans-serif--headline--500 b-font-weight-bold">
            Year-to-date summary
          </div>
          <div className="year-to-date-table-toggles-v2 beacon-on-light">
          <div>
            <AAMBeaconControl>
              <label slot="label" htmlFor="year-to-date-table-select">Accounts</label>
              <select id="year-to-date-table-select"
                      onChange={handleAccountGroupChange}
                      value={taxFilter.selection}>
                <option key="default" value="" disabled defaultValue={''}>
                  Select
                </option>
                {taxFilter.options.map((option, i) => (
                    <Option key={i} option={option} />
                ))}
              </select>
            </AAMBeaconControl>
          </div>
          <div>
            <div id="beacon-root" className={"ytd-year-toggle-v2"}>
              <AAMBeaconTabs
                  scrollable={false}
                  variant={'secondary'}
                  tab-type={'standard'}
                  selected={
                    props.defaultTaxYear === YEAR_OPTIONS[0].value ? '1' : '2'
                  }>
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={YEAR_OPTIONS[0].label}
                  value={'1'}
                />
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={YEAR_OPTIONS[1].label}
                  value={'2'}
                />
                <AAMBeaconTabPanel slot="tab-panel" value={'1'}>
                  <div className="ytd-table-container-v2">
                    <div className="ytd-table-v2">
                      <div>
                        {taxonomyDataV2.length === 0 || ytdTaxInformation.length === 0 ? (
                          <div className="no-data-available-v2 b-typography-sans-serif--headline--50">
                            No data available for the criteria selected.
                          </div>
                        ) : (
                          <TaxonomyTables
                            taxonomyData={taxonomyDataV2}
                            ytdTaxInformation={ytdTaxInformation}
                            displayYear={YEAR_OPTIONS[0].value}
                            isRetirementAdvisoryServiceClient={isRetirementAdvisoryServiceClient}
                            isCWV={isCWV}
                            uberId={uberId}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </AAMBeaconTabPanel>
                <AAMBeaconTabPanel slot="tab-panel" value={'2'}>
                  <div className="ytd-table-container-v2">
                    <div className="ytd-table-v2">
                      <div>
                        {taxonomyDataV2.length === 0 || ytdTaxInformation.length === 0 ? (
                          <div className="no-data-available-v2 b-typography-sans-serif--headline--50">
                            No data available for the criteria selected.
                          </div>
                        ) : (
                          <TaxonomyTables
                            taxonomyData={taxonomyDataV2}
                            ytdTaxInformation={ytdTaxInformation}
                            displayYear={YEAR_OPTIONS[1].value}
                            isRetirementAdvisoryServiceClient={isRetirementAdvisoryServiceClient}
                            isCWV={isCWV}
                            uberId={uberId}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </AAMBeaconTabPanel>
              </AAMBeaconTabs>
            </div>
          </div>
          </div>
        </div>
    );
  } else {
    return (<PageLoadingSpinner name={'Year To Date Summary'} />);
  }
};

YearToDateTableV2.propTypes = {
  tableData: object.isRequired,
  taxFilter: object.isRequired,
};

const mapStateToProps = (state) => ({
  isCWV: getCustomerWebView(state),
  uberId: getUberId(state),
  defaultTaxYear: getDefaultTaxYear(state),
  ytdTaxInformation: getYtdTaxInformation(state),
  hasTaxonomyDataError: getHasErrorTaxonomy(state),
  hasReceivedTaxonomyData: getHasReceivedTaxonomy(state),
  hasReceivedTaxFiltering: getHasReceivedTaxFiltering(state),
});

export default connect(mapStateToProps)(YearToDateTableV2);